/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverShiftAdminDto } from '../models/DriverShiftAdminDto';
import type { Pagination1OfDriverShiftListedAdminDto } from '../models/Pagination1OfDriverShiftListedAdminDto';
import type { PostShiftAcquireAdminRequest } from '../models/PostShiftAcquireAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverShiftsService {
    /**
     * **Required Policy:** `ManageDriverShifts`
     * @returns DriverShiftAdminDto OK
     * @throws ApiError
     */
    public static postAcquireShiftAdmin({
        requestBody,
    }: {
        requestBody?: PostShiftAcquireAdminRequest,
    }): CancelablePromise<DriverShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/drivershifts/acquire',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverShifts`
     * @returns Pagination1OfDriverShiftListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverShiftsAdmin({
        shiftId,
        driverId,
        isReleased,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
    }: {
        shiftId?: string,
        driverId?: number,
        isReleased?: boolean,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverShiftListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivershifts',
            query: {
                'shiftId': shiftId,
                'driverId': driverId,
                'isReleased': isReleased,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverShifts`
     * @returns DriverShiftAdminDto OK
     * @throws ApiError
     */
    public static getDriverShiftAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/drivershifts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
